module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/qa-c08921ec8cdc1b1a0e8e7f818cfdbe2f.svg";